import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'valueById', standalone: true })
export class ValueByIdPipe implements PipeTransform {
    transform(items: any[], id: number, field: string): any {
        return this.getValue(items, id, field);
    }

    getValue(items: any[], id: number, field: string) {
        if (!items || items.length <= 0) {
            return '';
        }

        const res = items.find((val) => {
            return val.id === id;
        });
        if (res && field) {
            return res[field];
        }

        return res ? res.text || res.value || res.name : '';
    }
}
